<div>
  <app-spotify></app-spotify>
  <app-code></app-code>
</div>
